import { render, staticRenderFns } from "./OfertasHeader.vue?vue&type=template&id=2b037a51"
import script from "./OfertasHeader.vue?vue&type=script&lang=js"
export * from "./OfertasHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports